import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function TaskDrawer({ task, defaultDate, onClose, onSaved }) {
  const isEdit = !!task;

  const [form, setForm] = useState({
    task_date: task?.task_date?.slice(0, 10) || defaultDate || '',
    title:     task?.title  || '',
    time:      task?.time   || '',
    owner:     task?.owner  || '',
    notes:     task?.notes  || '',
    status:    task?.status || 'pendiente',
    event_id:  task?.event_id || null,
  });
  const [eventName, setEventName]       = useState(task?.event_name || '');
  const [eventSearch, setEventSearch]   = useState('');
  const [eventResults, setEventResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  function set(k) { return e => setForm(f => ({ ...f, [k]: e.target.value })); }

  useEffect(() => {
    if (!eventSearch || eventSearch.length < 2) { setEventResults([]); return; }
    const t = setTimeout(async () => {
      setSearchLoading(true);
      try {
        const { data } = await api.get(`/events/search?q=${encodeURIComponent(eventSearch)}`);
        setEventResults(data);
      } catch (_) { setEventResults([]); }
      finally { setSearchLoading(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [eventSearch]);

  function selectEvent(ev) {
    setForm(f => ({ ...f, event_id: ev.id }));
    setEventName(ev.name);
    setEventSearch('');
    setEventResults([]);
  }

  function clearEvent() {
    setForm(f => ({ ...f, event_id: null }));
    setEventName('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      if (isEdit) {
        await api.put(`/tasks/${task.id}`, form);
      } else {
        await api.post('/tasks', form);
      }
      onSaved();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <h2 className="modal-title">{isEdit ? 'Editar tarea' : 'Nueva tarea'}</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Título *</label>
            <input className="input" required value={form.title} onChange={set('title')} autoFocus />
          </div>

          <div className="form-group">
            <label className="form-label">Fecha *</label>
            <input className="input" type="date" required value={form.task_date} onChange={set('task_date')} />
          </div>

          <div className="agenda-form-row">
            <div className="form-group">
              <label className="form-label">Hora</label>
              <input className="input" placeholder="10:00" value={form.time} onChange={set('time')} />
            </div>
            <div className="form-group">
              <label className="form-label">Responsable</label>
              <input className="input" value={form.owner} onChange={set('owner')} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Evento vinculado</label>
            {form.event_id ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className="task-event-chip" style={{ fontSize: 12, padding: '3px 10px' }}>{eventName}</span>
                <button type="button" className="btn btn-ghost btn-sm" onClick={clearEvent}>✕</button>
              </div>
            ) : (
              <>
                <input
                  className="input"
                  placeholder="Buscar evento…"
                  value={eventSearch}
                  onChange={e => setEventSearch(e.target.value)}
                />
                {searchLoading && <div className="text-mute text-sm" style={{ marginTop: 4 }}>Buscando…</div>}
                {eventResults.length > 0 && (
                  <div className="import-dropdown">
                    {eventResults.map(r => (
                      <div key={r.id} className="import-option" onClick={() => selectEvent(r)}>
                        <div className="fw-700">{r.name}</div>
                        <div className="text-mute text-sm">{r.event_date?.slice(0, 10)}{r.place ? ` · ${r.place}` : ''}</div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Notas</label>
            <textarea className="input" rows="2" value={form.notes} onChange={set('notes')} style={{ resize: 'vertical' }} />
          </div>

          {isEdit && (
            <div className="form-group">
              <label className="form-label">Estado</label>
              <select className="input" value={form.status} onChange={set('status')}>
                <option value="pendiente">Pendiente</option>
                <option value="finalizado">Finalizado</option>
              </select>
            </div>
          )}

          {error && <div className="text-red text-sm" style={{ marginBottom: 12 }}>{error}</div>}

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-ghost" onClick={onClose} disabled={saving}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Guardando…' : isEdit ? 'Guardar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
